export const fieldTranslations = {
  // DerivativeBarrier fields
  structured_product_id: "Id du produit structuré",
  structured_product_name: "Produit structuré",
  underlying_id: "Id du sous-jacent",
  underlying_name: "Sous-jacent",
  weight: "Pondération",
  final_strike_price: "Prix de strike initial",

  // Technical fields
  created_at: "Créé le",
  updated_at: "Mis à jour le",
};

export default fieldTranslations;
